<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head">Foreword</h1>
<p class="noindent">As a knitter you will already know that there is much more to making something with yarn than the sticks and string in your hands. You bring something to your work that no one else can; your voice, your creativity, your hopes, ideas, strengths, and lessons learned. In all of that your knitting becomes a unique part of who you are as it grows. Your voice is in the fabric.</p>
<p class="indent1">Anna Bauer recognised the power of this when she fell in love with Hønsestrik, a three-part Danish book series by Kirsten Hofstetter. The books encouraged people to rebel against traditional knits and the big hungry yarn companies who would only allow you to buy a pattern if you bought the specific yarn required to go with it. The idea was to throw off following the pattern, and be proud of not fitting into the mainstream sizes, colours and styles: to think outside of the boxes big money wants to put us in. It became a movement all of its own.</p>
<p class="indent1">What’s great about giving people the power to go off-pattern, and start looking at their WIPs as something that is so much more, is that it connects us like many wildly creative things do. When you find the confidence to show who you really are, to be brave with your ideas and to tell your own story it brings you closer to the rest of the world. People may see something in your work that lights something up in them, or a similarity that makes them feel less alone. In today’s climate this has more importance than ever.</p>
<p class="indent1">This book is a testament to Anna’s love of the movement, her commitment to the wonder that is knitting with colour, creativity, and character, and her passion for every creator to find their own voice in every stitch they make.</p>
<p class="indent1">The patterns here are a starting point for great stitched leaps in which ever directions your heart, head, and hands take you. Anna is offering you the tools to begin falling in love with what you can do, and what you can share with others. In her own love story she is really encouraging us to tell our own.</p>
<p class="noindent3">Happy knitting outside the box!</p>
<p class="noindent1"><b>Lauren O’Farrell</b></p>
<p class="noindent"><b>(aka Deadly Knitshade)</b></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?1a236559